import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReviewEntryAiSuggestionsWrapper = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${Spacing.S16};
  width: 100%;
`
